import React, { Component } from 'react';
import {Auth} from 'aws-amplify';

class LogIn extends Component {

  state = {
    inputUsername: '',
    inputPassword: '',
    inputPasswordResetCode: '',
    inputNewPassword1: '',
    inputNewPassword2: '',
    resettingPassword: false
  }

  componentDidMount() {

  }

  render() {

    const {
      updateInput,
      handleSignIn,
      handleResetPasswordEmail,
      toggleResetPassword,
      handleResetPassword
    } = this;

    const {
      inputUsername,
      inputPassword,
      inputPasswordResetCode,
      inputNewPassword1,
      inputNewPassword2,
      resettingPassword
    } = this.state;

    return (
      <div className="LogInPage">
        <h1>{resettingPassword ? 'Reset Password' : 'Log In'}</h1>
        <label htmlFor="inputUsername">Username</label>
        <input id="inputUsername" value={inputUsername} onChange={updateInput}/>
        {
          !resettingPassword &&
          <React.Fragment>
            <label htmlFor="inputPassword">Password</label>
            <input id="inputPassword" value={inputPassword} onChange={updateInput} type="password"/>
            <button onClick={handleSignIn}>Sign In</button>
          </React.Fragment>
        }
        {
          resettingPassword &&
          <React.Fragment>
            <button onClick={handleResetPasswordEmail}>Send Password Reset Email</button>
            <label htmlFor="inputPasswordResetCode">Password Reset Code</label>
            <input id="inputPasswordResetCode" value={inputPasswordResetCode} onChange={updateInput}/>
            <label htmlFor="inputNewPassword1">New Password</label>
            <input id="inputNewPassword1" value={inputNewPassword1} onChange={updateInput} type="password"/>
            <label htmlFor="inputNewPassword2">Confirm New Password</label>
            <input id="inputNewPassword2" value={inputNewPassword2} onChange={updateInput} type="password"/>
            <button onClick={handleResetPassword}>Submit</button>
          </React.Fragment>
        }
        <button onClick={toggleResetPassword}>{resettingPassword ? 'Cancel' : 'Forgot Password'}</button>
      </div>
    );
  }

  updateInput = e => {
    this.setState({[e.target.id]: e.target.value});
  }

  toggleResetPassword = () => {
    this.setState({resettingPassword: !this.state.resettingPassword});
  }

  handleSignIn = () => {

    const {inputUsername, inputPassword} = this.state;
    const {pushToLog, updateUserState} = this.props;

    if (inputUsername === '') pushToLog('Username cannot be blank.');
    else if (inputPassword === '') pushToLog('Password cannot be blank.');
    else {
      Auth.signIn(inputUsername.toLowerCase(), inputPassword)
      .then(res => {

        this.setState({inputUsername: '', inputPassword: ''});

        if (res.challengeName === 'NEW_PASSWORD_REQUIRED') pushToLog('You must change your password.');
        else if (res.challengeName === 'MFA_SETUP') pushToLog('Multi factor authentication must be setup.');
        else if (res.challengeName === 'SOFTWARE_TOKEN_MFA') pushToLog('Enter your MFA code.');

        updateUserState({challengeName: res.challengeName, firstTimeUser: res});

      })
      .catch(err => {
        if (err.message === 'User does not exist.') pushToLog('Incorrect username or password.');
        else if (err.message === 'Incorrect username or password.') pushToLog('Incorrect username or password.');
        else {
          console.log(err);
        }
      });
    }

  }

  handleResetPasswordEmail = () => {

    const {inputUsername} = this.state;
    const {pushToLog} = this.props;

    if (inputUsername === '') pushToLog('Username cannot be blank.');
    else {
      Auth.forgotPassword(inputUsername)
      .then(res => {
        pushToLog('Password reset email sent.');
      })
      .catch(err => {
        if (err.message === 'Username/client id combination not found.') pushToLog('Username not found.');
        else if (err.message === 'User password cannot be reset in the current state.') pushToLog('User password cannot be reset.');
        else {
          console.log(err);
        }
      });
    }

  }

  handleResetPassword = () => {

    const {inputPasswordResetCode, inputUsername, inputNewPassword1, inputNewPassword2} = this.state;

    const {pushToLog} = this.props;

    const specialCharRegex = /[ !"#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~]/;

    if (inputPasswordResetCode === '') pushToLog('Password reset code cannot be blank.');
    else if (inputUsername === '') pushToLog('Username cannot be blank.');
    else if (inputNewPassword1 !== inputNewPassword2) pushToLog('Passwords must match.');
    else if (inputNewPassword1 === '') pushToLog('Passwords cannot be blank.');
    else if (inputNewPassword1.length < 8) pushToLog('Password must be at least 8 characters long.');
    else if (!/[0-9]/.test(inputNewPassword1)) pushToLog('Password must contain at least one number.');
    else if (!/[a-z]/.test(inputNewPassword1)) pushToLog('Password must contain at least one lower case letter.');
    else if (!/[A-Z]/.test(inputNewPassword1)) pushToLog('Password must contain at least one upper case letter.');
    else if (!specialCharRegex.test(inputNewPassword1)) pushToLog('Password must contain at least one special character.');
    else {
      Auth.forgotPasswordSubmit(inputUsername, inputPasswordResetCode, inputNewPassword1)
      .then(res => {
        pushToLog('Password successfully reset.');
        this.setState({inputPasswordResetCode: '', inputNewPassword1: '', inputNewPassword2: '', resettingPassword: true});
      })
      .catch(err => {
        if (err.message === 'Invalid code provided, please request a code again.') pushToLog('Invalid password reset code. Request a new code and try again.');
        else if (err.message === 'User password cannot be reset in the current state.') pushToLog('User password cannot be reset.');
        else {
          console.log(err);
        }
      });
    }

  }

}

export default LogIn;


// WEBPACK FOOTER //
// ./src/components/content/user/userComponents/logIn.js